/*
 *
 * Producer -- Alvin
 * Time -- 2018/7/26
 * Function -- Entry for creating Google analytics wrapper
 *
 */
import GoogleAnalyticsWrapper from './googleanalytics-wrapper/src';

export default GoogleAnalyticsWrapper({debug: true});


// WEBPACK FOOTER //
// ./common/Utils/GoogleAnalytics.js